import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-stage text-silverBright" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjg9vlcoy9m7" />
      <main data-id="element-2" data-mp="3rc9em985thya">
        <Hero data-id="element-3" data-mp="3rcj7c4kla37o" />
        <SocialProof data-id="element-4" data-mp="3rbzmaezn6ypf" />
        <Testimonials data-id="element-5" data-mp="3rdkh85pvcjnt" />
        <ProblemSection data-id="element-6" data-mp="3recf5n6xuth9" />
        <SystemSection data-id="element-7" data-mp="5yh2n2cyzbp" />
        <ModulesSection data-id="element-8" data-mp="680tswt8a8y" />
        <BonusSection data-id="element-9" data-mp="5gel8p3rovc" />
        <UrgencySection data-id="element-10" data-mp="82jf0klzq9v" />
        <PricingSection data-id="element-11" data-mp="2zld0746gb58w" />
        <MoreResults data-id="element-12" data-mp="2zm4y4lnitf2c" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo6bandcp36" />
        <FAQ data-id="element-14" data-mp="2zng0ch1bierc" />
        <ClosingSection data-id="element-15" data-mp="33moqzd129wio" />
        <SummaryTable data-id="element-16" data-mp="33lx02fiesmyq" />
        <FinalCta data-id="element-17" data-mp="33n6zb810016y" />
      </main>
      <Footer data-id="element-18" data-mp="33oi1j3esp0vy" />
      <PurchaseNotification data-id="element-19" data-mp="38m1fs3bhtdnw" />
    </div>;
}